import { ButtonsetSingleWebElementBase } from './ButtonsetSingleWebElementBase';

/**
 * The component WebElement for [oj-c-buttonset-single](../../jsdocs/oj-c.ButtonsetSingle.html).
 * Do not instantiate this class directly, instead, use
 * [findButtonsetSingle](../functions/findButtonsetSingle.html).
 */
export class ButtonsetSingleWebElement extends ButtonsetSingleWebElementBase {
  // Put overrides here
}
